import { CustomButton } from "../components/global/CustomButton"
import { Link, useNavigate } from "react-router-dom"
import { useState, useContext, useEffect } from "react";
import { UserContext } from "../contexts/UserContext";
import { GoogleLogin } from '@react-oauth/google';
import { CustomGoogleButton } from "../components/global/CustomGoogleButton";
import "../styles/signin.css"

export function Signup() {
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [profilePicture, setProfilePicture] = useState(null)

    const navigate = useNavigate()

    const userDataContext = useContext(UserContext)
    const { dispatch } = userDataContext

    useEffect(() => {
        async function createProfilePicture() {
            const profileImage = await fetch("/images/user.svg")
            const blob = await profileImage.blob()

            const fileReader = new FileReader()
            fileReader.readAsDataURL(blob)
            fileReader.onload = () => {
                setProfilePicture(fileReader.result)
            }
        }

        createProfilePicture()
    }, [])

    async function handleSignup() {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/signup`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ name, email, password, profilePicture })
        })
        const json = await response.json()
    
        if(response.ok) {
            const { user, token } = json
            localStorage.setItem("user", JSON.stringify({ user, token }))
            dispatch({ type: "LOGIN", payload: { user, token } })
            navigate("/")
        }
    }

    return (
        <div className="signin main signup d-flex align-items-center justify-content-between">

            <img src="/images/login-image.jpg" alt="" />

            <div className="signin-form">
                <div className="form-title mb-2">Create an account</div>
                <p className="text-black">Enter your details below</p>

                <div className="d-flex flex-column mb-4">
                    <input
                        type="text"
                        placeholder="Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Email or Phone number"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>

                <div className="d-flex flex-column gap-2">
                    <CustomButton
                        color="primary"
                        text="Create Account"
                        btnFunction={handleSignup}
                    />

                    <CustomGoogleButton text="Sign up" />
                </div>
                
                <div className="mt-5 text-center already-text">
                    Already have an account? <Link to="/login">Log in</Link>
                </div>

                <div className="google-signin-button">
                    {/*
                        using the GoogleLogin component displays the sign in with google button, and if the user is logged in his google account it displays a button with his name, email and google profile picture. it is easy to implement but you can't style the button at all.
                        on successful login, the onSuccess function returns an object which has 3 properties : clientId, credential & select_by. the credential is an encoded jwt token which has the user data such as email, profile picture...
                    */}
                    {/*
                        <GoogleLogin
                            onSuccess={(response) => console.log(response)}
                            onError={(error) => console.log(error)}
                            text="signup_with"
                        />
                    */}
                </div>

            </div>

        </div>
    )
}